const tr = {
  SIDMedicalAppointmentsReports: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      cpf: 'CPF',
      specialty: 'Especialidade',
      doctor_init_at: 'Início da consulta',
      doctor_end_at: 'Fim da consulta',
      attendant_end_at: 'Fim do atendimento',
      created_at: 'Cadastro do usuário',
      consultation_time: 'Tempo de consulta',
      doctor: 'Médico',
      service_exit: 'Saída de Atendimento',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      ignore_service_exit: 'Desconsiderar Saída de Atendimento',
      no_service_exit: 'Sem saída registrada',
    },
    defSingular: 'Relatório de consultas da empresa Saúde Id',
  },
};

export default tr;
